import CustomComponent from "../CustomComponent";

export class ButtonComponent extends CustomComponent {
  static key = 'lta-button';

  static get observedAttributes() {
    return [
      'label',
      'tag',
      'size',
      'type',
      'button-type',
      'is-block',
      'is-dismiss-modal',
      'data-clipboard-target',
      'form',
      'classes',
      'href'
    ];
  }

  render() {
    // Destructure props with sensible defaults
    const {
      label = 'LTA Button',
      tag = 'button',
      target= '',
      size = 'default',
      type = 'primary',
      buttonType = 'button',
      isBlock = 'false',
      isDismissModal = 'false',
      dataClipboardTarget = '',
      form = '',
      classes = '',
      href = ''
    } = this.props;

    // Build class string
    const classNames = [
      'lta-btn',
      `lta-btn--${size}`,
      `lta-btn--${type}`,
      (isBlock === true || isBlock === 'true') ? 'lta-btn--block' : '',
      classes
    ].filter(Boolean).join(' ');

    // Build extra attributes string
    let extraAttrs = '';
    if (tag === 'button') {
      extraAttrs += ` type="${buttonType}"`;
    }
    if (form) extraAttrs += ` form="${form}"`;
    if (isDismissModal === true || isDismissModal === 'true') extraAttrs += ' data-dismiss="modal"';
    if (dataClipboardTarget) extraAttrs += ` data-clipboard-target="${dataClipboardTarget}"`;

    return `
      <${tag}${extraAttrs} ${target && `target=${target}`} class="${classNames}" ${href ? `href="${href}"` : ''} tabindex="0" role="button" aria-label="${label}">${label}</${tag}>
    `;
  }
}

export default ButtonComponent;